import {Component, HostListener, Input} from '@angular/core';
import {ValidationErrors} from '@angular/forms';

@Component({
    selector: 'vui-input-validations',
    templateUrl: './input-validations.component.html',
    styleUrls: ['./input-validations.component.scss']
})
export class InputValidationsComponent {
    public _errors: Array<any>;
    public hovered: boolean;

    constructor() {
        this._errors = new Array();
    }

    @HostListener('mouseleave')
    public blur(): void {
        this.hovered = false;
    }

    @Input()
    public set errors(errors: ValidationErrors) {
        this._errors = errors ? Object.entries(errors) : new Array();
    }

    @HostListener('mouseenter')
    public hover(): void {
        this.hovered = true;
    }
}
